import { SCol } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useLocation } from 'react-router-dom';

import Loading from '../../components/loading';
import PageNotFound from '../../components/page-not-found';
import PrequalLandingPage from '../../components/prequal-questionnaire';
import PrequalEndPage from '../../components/prequal-questionnaire/end-pages/end-page';
import PrequalQuestionPage from '../../components/prequal-questionnaire/questions';
import { hideHeaderSignIn } from '../../lib/aui-header';
import { fetchQuestionnaireConfig } from '../../lib/side-effects/prequal-questionnaire';
import { selectState } from '../../selectors';

import { QuestionnaireEligibility } from '../../../../types/prequal-questionnaire';
import { useAppDispatch } from '../../hooks/use-app-dispatch';

const PrequalQuestionnaireContainer = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const {
    questionnaire: { config },
    account: { isLoggedIn },
  } = useSelector(selectState);
  const searchParams = new URLSearchParams(location.search);
  // NOTE: pre-qual feature flag is ?q=true
  const showQuestionnaire = searchParams.get('q');

  useEffect(hideHeaderSignIn, []);

  useEffect(() => {
    if (!config) {
      dispatch(fetchQuestionnaireConfig());
    }
  }, [config]);

  if (showQuestionnaire !== 'true') return <PageNotFound />;
  if (!config) return <Loading />;

  if (config.eligibility === QuestionnaireEligibility.New && isLoggedIn) {
    console.log('NO WAY JOSE!');
    // TODO: when decision is made, show modal/page communicating to user
    // that they are not eligible for this flow
    // irony: not eligible for pre-qualification
  }

  return (
    <SCol span='7' center='' className='margin-top-md'>
      <Switch>
        <Route exact path='/question/start' component={PrequalLandingPage} />
        <Route exact path='/question/end' component={PrequalEndPage} />
        <Route path='/question/:questionNumberParam' component={PrequalQuestionPage} />
        <Route component={PageNotFound} />
      </Switch>
    </SCol>
  );
};

export default PrequalQuestionnaireContainer;
